module.exports = __webpack_public_path__ + "static/overheadheader-9a89abf2c9b74d2e9ade42bb92be1251.png";